import React, { FC } from 'react';
import { useTranslation } from '../../../utils/useTranslation';
import { IconProduct } from '../../icon/IconProduct';
import { Flex } from '../../layout/Flex';
import { Typography } from '../../typography/Typography';

export const PostProductsNotFound: FC = () => {
    const t = useTranslation();

    return (
        <Flex
            direction="column"
            alignItems="center"
            justifyContent="center"
            minHeight="100vh"
            px={4}
            py={8}
        >
            <Flex
                alignItems="center"
                justifyContent="center"
                width={80}
                height={80}
                borderRadius="50%"
                backgroundColor="var(--background-secondary)"
                mb={3}
            >
                <IconProduct fontSize={40} color="var(--color-secondary)" />
            </Flex>

            <Typography variant="title2" weight="bold" textAlign="center" mb={2}>
                {t('Товары не найдены')}
            </Typography>

            <Typography
                variant="body"
                color="var(--color-secondary)"
                textAlign="center"
                maxWidth="300px"
            >
                {t('К сожалению, товары для этого поста недоступны или были удалены')}
            </Typography>
        </Flex>
    );
};
